'use strict';

require('./module.js');

require('./userService.js');


//////////////////
// WEBPACK FOOTER
// ./src/environment/winres/boot.js
// module id = 538
// module chunks = 2